import React from 'react';
import { useTimer } from '../context/TimerContext';

interface CountdownTimerProps {
  className?: string;
  showLabel?: boolean;
}

export function CountdownTimer({ className = '', showLabel = true }: CountdownTimerProps) {
  const { timeRemaining, isSiteActive, isExpired } = useTimer();

  // Format time in readable format
  const formatTime = (seconds: number): string => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts: string[] = [];
    if (days > 0) parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`);
    if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'Hour' : 'Hours'}`);
    if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'Minute' : 'Minutes'}`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs} ${secs === 1 ? 'Second' : 'Seconds'}`);

    if (parts.length === 1) return parts[0];
    if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;
    return parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1];
  };

  if (!isSiteActive) {
    return (
      <div className={`countdown-timer ${className}`}>
        {showLabel && <span className="countdown-label">Site Status: </span>}
        <span className="countdown-value inactive">Inactive</span>
      </div>
    );
  }

  if (isExpired) {
    return (
      <div className={`countdown-timer ${className}`}>
        {showLabel && <span className="countdown-label">Time Remaining: </span>}
        <span className="countdown-value expired">EXPIRED</span>
      </div>
    );
  }

  return (
    <div className={`countdown-timer ${className}`}>
      {showLabel && <span className="countdown-label">Time Remaining: </span>}
      <span className="countdown-value">{formatTime(timeRemaining)}</span>
    </div>
  );
}

export default CountdownTimer;
